import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'

class Section extends PureComponent {

    render() {
        const {classes, className, children, extend=false, dataCy} = this.props;
        return <section className={cn(classes.root, className, {extend})} data-cy={dataCy}>
            {children}
        </section>
    }
}

export default injectSheet((theme) => ({
    root: {
        width: '100%',
        maxWidth: theme.content.widthLarge,
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: [0, theme.spacing.tiny],
        [theme.breakpoint('tablet')]: {
            padding: [0, theme.spacing.normal],
        }
    },
}))(Section)



// WEBPACK FOOTER //
// ./src/components/Widgets/Section.js